import { reviewStatusBadge, reviewStatusLabel } from "@/config/cta-mapa-config";

interface TreeReviewBadgeProps {
  status: string;
  size?: "sm" | "md";
}

export default function TreeReviewBadge({ status, size = "sm" }: TreeReviewBadgeProps) {
  const sizeClass = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  if (!status) return <span className="text-xs text-foreground-400">—</span>;
  const badge = reviewStatusBadge[status.toUpperCase()] || "bg-background-100 text-foreground-500";
  return <span className={`badge ${sizeClass} ${badge}`}>{reviewStatusLabel(status)}</span>;
}
